<template>
  <section class="main">
            <div class="content_page_title">
                <h1>Je crée mon compte</h1>
            </div>
            <div class="main_content">
                <form ref="signupForm" v-on:submit.prevent>
                    <div class="form">
                        <div class="form_group half">
                            <label for="siret">SIRET *</label>
                            <input id="siret" type="text" v-model="siret" required/>
                        </div>
                        <div class="form_group half">
                            <label for="email">Adresse e-mail *</label>
                            <input id="email" type="email" v-model="email" required/>
                        </div>
                        <div class="form_group half">
                            <label for="mdp">Mot de passe *</label>
                            <input id="mdp" type="password" v-model="password" minlength="8" required/>
                        </div>
                        <div class="form_group half">
                            <label for="confirmationMdp">Confirmation de votre mot de passe *</label>
                            <input id="confirmationMdp" type="password" minlength="8" v-model="passwordConfirmation" required/>
                        </div>

                        <div class="errorPassword" v-if="errorPassword">{{passwordErrorMessage}}</div>

                        <div class="form_message" v-if="siretUnRecognised" id="errorMsgSiret">
                            <div class="form_message_text error_message" >
                                Le N° de SIRET saisi n'a pas été retrouvé dans la base de données des antennistes de l'ANFR ou n'a pas été charté.
                                <br />Afin de poursuivre, merci de bien vouloir compléter les informations supplémentaires ci-dessous.
                            </div>
                        </div>
                        <div class="if_siret_unrecognized line" v-if="siretUnRecognised">
                          <div class="form_group full">
                              <label for="denomination">Dénomination commerciale *</label>
                              <input id="denomination" type="text" v-model="denomComm" required/>
                          </div>
                          <div class="line half">
                            <div class="form_group half">
                                <label for="nom">Nom *</label>
                                <input id="nom" type="text" v-model="nom" required/>
                            </div>
                            <div class="form_group half">
                                <label for="prenom">Prénom *</label>
                                <input id="prenom" type="text" v-model="prenom" required/>
                            </div>
                          </div>
                          <div class="line half">
                            <div class="form_group half">
                                <label for="tel">N° de téléphone *</label>
                                <input id="tel" type="tel" pattern="^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$" v-model="tel" required/>
                            </div>
                          </div>
                            <div class="line half">
                                <div class="form_group one_quarter">
                                    <label for="numAddresse">N° *</label>
                                    <input id="numAddresse" type="text" v-model="numAddresse" required/>
                                </div>
                                <div class="form_group three_quarter">
                                    <label for="address">Adresse *</label>
                                    <input id="address" type="text" v-model="adresse" required/>
                                </div>
                            </div>
                            <div class="line half">
                                <div class="form_group half">
                                    <label for="cp">Code postal *</label>
                                    <input id="cp" type="text" pattern="^([0-9]{5})$" v-model="cp" required/>
                                </div>
                                <div class="form_group half">
                                    <label for="ville">Ville *</label>
                                    <search-commune ref='searchCommune'></search-commune>
                                </div>
                            </div>
                        </div>
                        <div class="form_actions_bar">
                            <input type="submit" value ="Valider" @click="signUp" class="button blue"/>
                        </div>
                        <a href="index.html" class="button dark">Retour à l'accueil</a>
                    </div>
                </form>
            </div>
            <div id ="scrollTo"></div>
        </section>
    </template>
    <script>
    import axios from 'axios'
    import SearchCommune from './SearchCommune.vue'

    /* eslint-disable */
    export default {
      name: 'Inscription',
      components: {SearchCommune},
      data() {
        return {
          validCompte: false,
          invalidCompte: false,
          ville: null,
          cp: null,
          adresse: null,
          numAddresse: null,
          tel: null,
          denomComm: null,
          password: null,
          passwordConfirmation: null,
          siret: null,
          email: null,
          nom: null,
          prenom: null,
          siretUnRecognised: false,
          partenaire: false,
          utilisateur: null,

          // Vérifications des données du formulaire
          formulaireOK: null,
          errorPassword: false,
          passwordErrorMessage: null

        }
      },
      created() {},
      destroyed() {
        this.validCompte= false
        this.invalidCompte= false
        this.siretUnRecognised= false
        this.ville= null
        this.cp= null
        this.adresse= null
        this.numAddresse= null
        this.tel= null
        this.denomComm= null
        this.password= null
        this.passwordConfirmation= null
        this.siret= null
        this.email= null
        this.nom= null,
        this.prenom = null,
        this.partenaire= false,
        this.utilisateur = null,

        this.formulaireOK = null,
        this.samePassword = null,
        this.passwordErrorMessage = null;
      },
      methods: {

        signUp(){
          axios.get('/utilisateur/checkPassword', {
            params: {
              password: this.password,
              passwordConfirmation: this.passwordConfirmation
            }
          }).then(response => {
            if(!response.data.success) {
              this.formulaireOK = false;
              this.errorPassword = true;
              this.passwordErrorMessage = response.data.msg;
            } else {
              this.errorPassword = false;
              if(this.$refs['signupForm'].checkValidity()) {
                if(!this.siretUnRecognised){
                  this.checkSiret();
                } else {
                  this.saveInSas();
                }
              }
            }
          });
        },

        checkSiret(){
            axios.get('/antenniste' + '?siret=' + this.siret + '&email='+ (this.email).replace("+","_plus_")).then(response => {
              if(response.data && response.data.data.length > 0 ){
                var antenniste = response.data.data[0]
                if(antenniste.idstatutcharte && antenniste.idstatutcharte != null){
                  this.partenaire = (antenniste.idstatutcharte.nom.toUpperCase() === 'OUI' ? true : false)
                }
                this.siretUnRecognised = false
                if(this.$refs['signupForm'].checkValidity()){
                   this.createPrtvUser();
                }

              }else {
                this.siretUnRecognised = true
                this.$notify({
                  group: 'general-notification',
                  type: 'warn',
                  text: "Le N° de SIRET saisi n'a pas été retrouvé ou n'a pas été charté"
                })
                this.$nextTick(() => {
                  document.getElementById('errorMsgSiret').scrollIntoView();
                });
              }
            }).catch(error => {
              if(error.response) {
                this.$notify({
                  group: 'general-notification',
                  type: 'error',
                  text: error.response.data.message
                })
                this.focusDown();
              }
            })
        },
        focusDown(){
          document.getElementById('scrollTo').scrollIntoView();
        },
        createPrtvUser(){
          if(this.siret.match(/[0-9]{14}/g)){
            this.utilisateur = {siret: this.siret,
              identifiant:this.email,
                password:this.password,
                partenaire:this.partenaire}
            axios.post('/utilisateur', this.utilisateur).then(response => {
                if(response.data){
                  this.$notify({
                      group: 'general-notification',
                      type: 'success',
                      duration: 15000,
                      text: "Votre compte a bien été enregistré, un email de confirmation va vous être envoyé afin de valider votre accès"
                    })
                    this.$router.push('/')
                }
            }).catch(error => {
              if(error.response.data.message.indexOf('existe') !== -1){
                this.$notify({
                    group: 'general-notification',
                    type: 'error',
                    text: error.response.data.message
                  })
              }
              console.error('Création utilisateur', error.response)
            })
          } else {
            this.$notify({
              group: 'general-notification',
              type: 'error',
              text: 'Le numéro de siret n\'est pas au bon format'
            })
          }
        },
        saveInSas(){
          this.utilisateur = {
            siret: this.siret,
            identifiant:this.email,
            password:this.password,
            partenaire:this.partenaire
          }


          this.antenniste = {
            siret: this.siret,
            courriel:this.email,
            civilite: "M",
            password:this.password,
            partenaire:this.partenaire,
            nomCommercial: this.denomComm,
            appareil_mesure_marque: "inconnu",
            url_site: "inconnu",
            telephone:this.tel,
            numVoie: this.numAddresse,
            voie: this.adresse,
            codepostal:this.cp,
            commune: JSON.stringify(this.$refs.searchCommune.getSelectedId()),
            nom: this.nom,
            prenom: this.prenom
          }
          axios.post('/utilisateur/insas', {utilisateur : this.utilisateur , antenniste: JSON.stringify(this.antenniste)}).then(response => {
            if(response.data){
              this.$notify({
                  group: 'general-notification',
                  type: 'success',
                  duration: 10000,
                  text: "Votre compte a bien été enregistré, un email de confirmation va vous être envoyé afin de valider votre accès"
                })
                this.$router.push('/');
            }
          }).catch(error => {
            if(error.response.data.message.indexOf('existe') !== -1){
              this.$notify({
                  group: 'general-notification',
                  type: 'error',
                  text: error.response.data.message
                })
            }
            if(error.response.data.message.indexOf('SIRET') !== -1){
              this.$notify({
                  group: 'general-notification',
                  type: 'error',
                  text: error.response.data.message
                })
            }
            console.error('Création utilisateur', error.response)
          })
        },
      }
    }
    </script>
<style>
.errorPassword {
  font-size: 12px;
  color: red;
}

.v-autocomplete-input {
  height: 30px;
  width: -webkit-fill-available;
  border: 1px solid #a8a8a8;
  padding: 6px 11px;
  font-size: 0.9em;
}

.v-autocomplete .v-autocomplete-list {
  position: absolute;
  overflow-y: scroll;
  max-height: 150px;
}
</style>
